// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Vehicle from './components/shared/vehicle';
import Home from './components/home';
import ContactUs from './components/shared/contact/ContactUs';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './global-const';
import { CarProvider } from './components/shared/carProvider';


const App = () => {
  return (
    <CarProvider>
  <ThemeProvider theme={theme}>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vehicles/:name" element={<Vehicle />} />
        <Route path ="/contact" element={<ContactUs/>}/>
      </Routes>
    </Router>
  </ThemeProvider>
  </CarProvider>
  );
};

export default App;
